export const Stone = Object.freeze({
  NONE: Symbol.for("none"),
  BLACK: Symbol.for("black"),
  WHITE: Symbol.for("white"),
  BOTH: Symbol.for("both"),
  OUT: Symbol.for("out"),
  UNKNOWN: Symbol.for("unknown"),

  parse(str) {
    const p = Symbol.for(str);
    for(const k in Stone) {
      if(p === Stone[k])
        return p;
    }

    return null;
  },

  intTable: [],

  ensureIntTable() {
    if(this.intTable.length === 0) {
      for(const k in Stone) {
        if(/^[A-Z].*/.test(k))
          this.intTable.push(Stone[k]);
      }
    }
  },

  fromInt(i) {
    this.ensureIntTable();
    return this.intTable[i];
  },

  toInt(s) {
    this.ensureIntTable();
    for(let i = 0; i < this.intTable.length; i++) {
      if(this.intTable[i] === s)
        return i;
    }
    return -1;
  },
});

export default class Board {
  #board;

  constructor(size, fill=Stone.NONE) {
    this.size = size;
    this.#board = new Int8Array(new ArrayBuffer(size * size));
    for(let i = 0; i < size * size; i++)
      this.#board[i] = Stone.toInt(fill);
  }

  clone() {
    const b = new Board(this.size);
    b.#board.set(this.#board);
    return b;
  }

  #isOut(x, y) {
    return x < 0 || x >= this.size || y < 0 || y >= this.size;
  }

  get(x, y) {
    return this.#isOut(x, y) ? Stone.OUT : Stone.fromInt(this.#board[y * this.size + x]);
  }

  put(x, y, stone) {
    if(stone != Stone.NONE && stone != Stone.BLACK && stone != Stone.WHITE)
      throw new Error(`Invalid Stone: ${stone.toString()}`);

    if(this.#isOut(x, y))
      throw new Error(`Invalid coords: (${x}, ${y})`);

    this.#board[y * this.size + x] = Stone.toInt(stone);
  }
}
